'use strict';

var $ = require('jquery');
var Radio = require('backbone.radio');
var Marionette = require('backbone.marionette');
var polyglot = require('../utilities/polyglot').default;

var DEFAULT_BUTTON_CLASS = 'grey';
var DEFAULT_BUTTON_MESSAGE = 'Close';
var DEFAULT_CLASS = 'coconut-modal';
var DEFAULT_ICON = 'info-circle';
var DEFAULT_ICON_COLOR = null;
var DEFAULT_MODAL_SIZE = 'small';
var DEFAULT_SHOW_ICON = true;
var DEFAULT_SKIPPABLE = false;
var DEFAULT_SKIP_MESSAGE = 'Don’t show this message again';

export default Marionette.View.extend({
  className: 'coconut-modal',
  template: require('./templates/toast.hbs'),
  events: {
    'click @ui.close': 'dismiss',
    'click @ui.skip': 'toggleSkip',
  },
  ui: {
    close: '.close-button',
    skip: '#skip-modal',
  },

  initialize: function(options) {
    this.buttonClass = options.buttonClass || DEFAULT_BUTTON_CLASS;
    this.buttonMessage = options.buttonMessage || polyglot.t('forms.error.close', { _: DEFAULT_BUTTON_MESSAGE });
    this.icon = options.icon || DEFAULT_ICON;
    this.iconColor = options.iconColor || DEFAULT_ICON_COLOR;
    this.message = options.message;
    this.modalSize = options.modalSize || DEFAULT_MODAL_SIZE;
    this.skippable = options.skippable || DEFAULT_SKIPPABLE;
    this.skipMessage = polyglot.t('forms.skip.message', { _: DEFAULT_SKIP_MESSAGE });
    this.className = options.className || DEFAULT_CLASS;
    this.showIcon = options.showIcon == null ? DEFAULT_SHOW_ICON : options.showIcon;
  },

  serializeData: function() {
    return {
      /**
       * The icon displayed within modal body.
       *
       * See Font-Awesome for available icons.
       */
      icon: this.icon,

      /**
       * Message displayed in modal body.
       */
      message: this.message,

      /**
       * Message displayed in modal button.
       */
      buttonMessage: this.buttonMessage,

      /**
       * Class of button.
       */
      buttonClass: this.buttonClass,

      /**
       * The size of the modal.
       *
       * Acceptable sizes are 'small', 'medium', 'large'.
       */
      modalSize: this.modalSize,

      /**
       * Color of the icon.
       *
       * Accepted values are 'error', 'success', or empty.
       */
      iconColor: this.iconColor,

      /**
       * Should we allow user to skip the modal.
       */
      skippable: this.skippable,

      /**
       * Message displayed to the user when the modal can be skipped.
       */
      skipMessage: this.skipMessage,

      /**
       * Has the user opted to skip the modal.
       */
      userWantsToSkip: this.userWantsToSkip(),

      /**
       * Should we show an icon in front of the message.
       */
      showIcon: this.showIcon,
    };
  },

  /**
   * Display the modal.
   */
  show: function() {
    this.$el.removeClass('hide');
    this.$el.addClass('show');
  },

  /**
   * Dismiss the modal.
   */
  dismiss: function(event) {
    this.$el.removeClass('show');
    this.$el.addClass('hide');
    Radio.channel('long-toast').trigger('hide');

    if (this.message === polyglot.t('messages.cookies') && $(event.target).hasClass('cookie')) {
      this.setCookiesAccepted();
    }
  },

  /**
   * Toggle whether the current modal should be skipped.
   */
  toggleSkip: function() {
    var value = this.ui.skip.prop('checked').toString();

    this.setStoredSetting(value);
  },

  /**
   * Determine if the user is able to skip the modal.
   *
   * @returns {boolean}
   */
  isSkippable: function() {
    return this.skippable == true;
  },

  /**
   * Hash the message.
   * Used for obfuscating the stored message in local storage.
   *
   * @returns {number}
   */
  hashMessage: function() {
    var hash = 0;
    var index;
    var character;

    if (this.message.length === 0) return hash;

    for (index = 0; index < this.message.length; index++) {
      character = this.message.charCodeAt(index);
      hash = ((hash << 5) - hash) + character;
      hash |= 0; // Convert to 32bit integer
    }

    return hash;
  },

  /**
   * Store the user's acceptance to cookie usage to cookie storage.
   */
  setCookiesAccepted: function() {
    $.cookie('cookiesAccepted', true, { expires: 90 });
  },

  /**
   * Retrieve the user's stored option from local storage.
   *
   * @returns {string | null}
   */
  getStoredSetting: function() {
    return localStorage.getItem(this.hashMessage());
  },

  /**
   * Store the user's selection to local storage.
   *
   * @param value
   */
  setStoredSetting: function(value) {
    return localStorage.setItem(this.hashMessage(), value);
  },

  /**
   * Determine if the user has selected to not display the message again.
   *
   * @returns {boolean}
   */
  userWantsToSkip: function() {
    return false;
  }
});
